import { TableFooter, TableRow, TableCell } from "@mui/material";
import useGrandTotal from "../../hooks/useGrandTotal";
import {
  NumberField,
  RecordContextProvider,
  TextField,
  usePermissions,
} from "react-admin";

const AccountPayableCorrectionFooterList = () => {
  const { data, isLoading, error } = useGrandTotal();
  const { permissions } = usePermissions();
  const canSeeCompanyColumn =
    permissions?.administrator ||
    permissions?.superadmin ||
    permissions?.update_company;

  // if (error) return <Error />;

  return (
    <RecordContextProvider value={data ? data : {}}>
      <TableFooter>
        <TableRow
          sx={{
            "& td": {
              borderTop: "1px solid rgba(224, 224, 224, 1) !important",
            },
            "& .MuiTypography-root": {
              color: (theme) => theme.palette.primary.main,
              fontWeight: "bold",
            },
          }}
        >
          <TableCell />
          <TableCell colSpan={canSeeCompanyColumn ? 5 : 4}>
            <RecordContextProvider value={{ name: "GRAND TOTAL" }}>
              <TextField source="name" />
            </RecordContextProvider>
          </TableCell>
          <TableCell sx={{ textAlign: "right" }}>
            <NumberField source="value" textAlign="right" />
          </TableCell>
          <TableCell />
        </TableRow>
      </TableFooter>
    </RecordContextProvider>
  );
};

export default AccountPayableCorrectionFooterList;
